module.exports = __webpack_public_path__ + "img/پاکت-کتان.c2567ec1.png";